import React, { useState } from "react";
import { motion } from "framer-motion";
import PersonImage from "../Component/real-ai.jpg";

const BusinessPromo = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <>
      <style>{`
        .containerss {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 50px;
          font-family: Arial, sans-serif;
          height: auto;
          background-color:white;
          overflow: hidden;
          flex-wrap: wrap;
        }

        .text-sectiony {
          max-width: 50%;
          text-align: left;
        }

        .image-sectiony {
          display: flex;
          justify-content: flex-start;
          width: 50%;
        }

        .imagess {
          width: 100%;
          max-width: 681px;
          border-radius: 10px;
        }

        .headingyss {
          font-size: 36px;
          font-weight: bold;
          color: #0e7f9d;
          text-align:left;
        }

        .bold {
          color: #ffe124;
        }

        .highlighted {
          color: #0e7f9d;
          border-bottom: 3px solid #ffe124;
          display: inline-block;
          text-align:left;
        }

        .paragraph {
          font-size: 17px;
          color: black;
          margin: 10px 0 20px;
          text-align:left;
          font-family: 'Poppins', sans-serif;
        }

        .buttonContainer {
          margin-top: 20px;
        }

        .downloadBtn {
          background-color: #ffe124;
          color: #2a0947;
          padding: 12px 25px;
          font-size: 20px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s ease;
          font-weight: bold;
        }

        @media (max-width: 768px) {
          .containerss {
            flex-direction: column-reverse;
            height: auto;
            padding: 30px 20px;
          }

          .text-sectiony,
          .image-sectiony {
            max-width: 100%;
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .headingyss {
            font-size: 30px;
          }

          .imagess {
            max-width: 90%;
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .headingyss {
            font-size: 26px;
          }

          .paragraph {
            font-size: 14px;
          }

          .downloadBtn {
            font-size: 16px;
            padding: 10px 20px;
          }
        }
      `}</style>

      <div className="containerss">
        {/* Image Section */}
        <motion.div
          className="image-sectiony"
          initial={{ opacity: 0, y: -100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img src={PersonImage} alt="Person" className="imagess" />
        </motion.div>

        {/* Text Section */}
        <motion.div
          className="text-sectiony"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p className="headingyss">
            AI/ML <span className="bold">Solutions</span> <br />
          </p>

          <motion.p
            className="paragraph"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            We provide cutting-edge Artificial Intelligence and Machine Learning solutions 
            tailored to transform your business processes, enhance decision-making, and 
            unlock new opportunities.
          </motion.p>

          <motion.p
            className="paragraph"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
          >
            From predictive analytics and natural language processing to computer vision 
            and recommendation engines, we design intelligent solutions that address 
            real-world business challenges.
          </motion.p>

          <motion.p
            className="paragraph"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            viewport={{ once: true }}
          >
            Our AI/ML services cover the entire lifecycle—from data collection and 
            preprocessing to model training, deployment, and continuous optimization. 
            With a focus on ethical AI and responsible practices, we deliver solutions 
            that drive innovation while maintaining transparency and trust.
          </motion.p>
        </motion.div>
      </div>
    </>
  );
};

export default BusinessPromo;
